import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgSelectModule } from "@ng-select/ng-select";
import { BackendService } from '../../core/services/backend.service';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { CustomDatePipe } from '../../core/pipes/date.pipe';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { DashboardNavComponent } from '../../core/components/dashboard-nav/dashboard-nav.component';

@Component({
  selector: 'app-dashboard',
  imports: [NgSelectModule, FormsModule, MatTableModule, CommonModule, CustomDatePipe, MenuBarComponent, FooterComponent, DashboardNavComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  isMenuOpen = false;
  selectedLang = 'EN';
  orders: any[] = [];
  displayedColumns = ['id', 'clientName', 'date', 'amount', 'status', 'assignedTo', 'actions'];
  dashboardStats: any = {};

  constructor(private router: Router, private backendService: BackendService) { }

  ngOnInit() {
    this.backendService.getOrders(true).subscribe(orders => {
      this.orders = orders.data.orders;
    });
    this.backendService.calculateDashboardStats().subscribe(stats => {
      console.log('Dashboard stats:', stats);
      this.dashboardStats = stats.data.stats;
    });
  }

  public viewOrder(order: any) {
    this.router.navigate([`dashboard/orders/${order.id}`]);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**
   * Count for a status over the last 31 days, from the stats endpoint.
   *
   * Not derived from `orders`: that list is the latest 10 for the table below,
   * so counting it would under-report as soon as there are more than ten.
   */
  statusCount(status: string): number {
    return this.dashboardStats?.statusCounts?.[status] ?? 0;
  }
}